import React, { useState } from "react";
import { Card, Row, Col } from "reactstrap";
import PageTitle from "../common/PageTitle";
import local from "../../localization/strings";
import UserManagementUsers from "./user-management-users";
import UserManagementGroups from "./user-management-groups";
import UserManagementAreas from "./user-management-areas";

const tabs = [{ id: 1, name: local.TS_Users }, { id: 2, name: local.TS_Groups }, { id: 3, name: local.TF_Areas }];

const UserManagement = () => {
	const [activeTab, setActiveTab] = useState(1);

	return (
		<>
			<Row>
				<Col>
					<PageTitle title={local.TF_User_Management} />
				</Col>
			</Row>
			<Card className="mb-4">
				<div className="nav nav-tabs">
					{tabs.map((t, k) => (
						<li key={k} onClick={() => setActiveTab(t.id)} className="nav-item">
							<div className={`nav-link ${activeTab === t.id ? "active" : ""}`}>{t.name}</div>
						</li>
					))}
				</div>
				<div className="p-3">
					{activeTab === 1 && <UserManagementUsers />}
					{activeTab === 2 && <UserManagementGroups />}
					{activeTab === 3 && <UserManagementAreas />}
				</div>
			</Card>
		</>
	);
};

export default UserManagement;
